export enum State {
  Initial,
  Loading,
  Loaded,
}
